import React from "react";
import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";
import { primaryColor } from "../../assets/styles/base";

export default (props) => {
  return (
    <div>
      <Dialog
        open={props.open}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">
          {props.dialogTitle || "Delete confirmation"}
        </DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            {props.dialogMessage ||
              `Are you sure you want to delete ${props.message}`}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={props.onCancel} color="inherit" variant="contained">
            Cancel
          </Button>
          <Button
            onClick={props.onConfirm}
            color="primary"
            autoFocus
            style={{ background: primaryColor[0] }}
            variant="contained"
          >
            {props.confirmText || "Delete"}
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
};
